/** @jsxImportSource theme-ui */
import React, { useMemo } from 'react';
import { Avatar, Flex, Text } from '@infotrack/zenith-ui';
import type { ITopFiveApiV2EndpointsTopFiveGetTopFiveStaffDto } from '@/api/models';
import { containerStyles, userInfoStyles } from './staffInfoCard.styles';

type StaffInfoCardProps = {
  staff: ITopFiveApiV2EndpointsTopFiveGetTopFiveStaffDto | null | undefined;
};

export const StaffInfoCard = ({ staff }: StaffInfoCardProps) => {
  const displayName = useMemo(() => {
    return (
      staff?.fullName ||
      `${staff?.firstName || ''} ${staff?.surname || ''}`.trim() ||
      'Unknown User'
    );
  }, [staff]);

  return (
    <Flex sx={containerStyles}>
      <Avatar name={displayName} aria-hidden="true" />
      <Flex sx={userInfoStyles}>
        <Text variant="feature">{displayName}</Text>
        <Text variant="small">
          #{staff?.employeeId || 'N/A'} {staff?.department || 'N/A'}
        </Text>
      </Flex>
    </Flex>
  );
};
